import { AnalysisFileType } from "../../../types/analysisFileTypes";
import GenericAnalysisFilesPage from "./GenericAnalysisFilesPage";


export default function BoughtVouchersAnalysisFilesPage() {
    return <GenericAnalysisFilesPage
        fileType={AnalysisFileType.BoughtVouchersAnalysisFile}
        title={"analysisPage.boughtVouchers.title"}
    />
}